<template>
  <!--<default-layout>-->
  <div>
    <!--    {{facilities}}-->
    <v-data-table
      :headers="headers"
      :items="facilities"
      :items-per-page="limit"
      :server-items-length="serverItemsLength"
      :options.sync="paginationOptions"
      :loading="loading"
      :fixed-header="true"
      class="elevation-2"
      :multi-sort="false"
      :must-sort="true"
      sort-by="date"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, 100]
      }"
      @update:options="updatePaginationOptions($event)"
    >
      <template v-slot:top>
        <v-row>
          <!-- SEARCH -->
          <v-col>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              @keyup.enter="
                searchClicked = true;
                search();
              "
              :disabled="search.length ? true : false"
            ></v-text-field>
          </v-col>

          <!-- SEARCH BUTTON-->
          <v-col>
            <v-btn
              class="primary mt-3"
              @click="
                searchClicked = true;
                search();
              "
              >Search
            </v-btn>

            <!-- CSV DOWNLOAD BUTTON -->
            <json-c-s-v
              class="pl-2"
              style="display: inline-block"
              :data="csvData"
              :labels="{
                companyId: 'Provider ID',
                companyName: 'Provider Name',
                facilityId: 'Listing ID',
                facilityName: 'Listing Name',
                city: 'City',
                zip: 'Zip',
                state: 'State',
                premiumClicks: 'Clicks',
                premiumCalls: 'Calls',
                callRevenue: 'Call Revenue',
                clickRevenue: 'Click Revenue',
                total: 'Total'
              }"
              :fields="[
                'companyId',
                'companyName',
                'facilityId',
                'facilityName',
                'city',
                'state',
                'zip',
                'premiumCalls',
                'callRevenue',
                'premiumClicks',
                'clickRevenue',
                'total'
              ]"
              :name="`${filename}.csv`"
            >
              <v-btn
                class="mt-3"
                color="primary"
                x-small
                fab
                :disabled="!facilities || !facilities.length"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </json-c-s-v>
          </v-col>
        </v-row>
      </template>

      <template v-slot:body.append>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="text-right"><strong>Totals:</strong></td>
          <td>{{ totalNumCalls }}</td>
          <td>{{ callsTotal | dollarsCents }}</td>
          <td>{{ totalNumClicks }}</td>
          <td>{{ clicksTotal | dollarsCents }}</td>
          <td>{{ totalTotal | dollarsCents }}</td>
          <td></td>
        </tr>
      </template>
    </v-data-table>
  </div>
  <!--</default-layout>-->
</template>

<script>
import { getActivityRevenueReport } from "../../api/report";

import JsonCSV from "vue-json-csv";
import Decimal from "decimal.js-light";
export default {
  name: "ActivityReport",
  title: "Activity",
  data() {
    return {
      facilities: [],
      limit: 10,
      offset: 0,
      loading: true,
      serverItemsLength: 0,
      search: "",

      headers: [
        { text: "Provider ID", value: "companyId", sortable: false },
        { text: "Provider Name", value: "companyName", sortable: false },
        { text: "Listing ID", value: "facilityId", sortable: false },
        { text: "Listing Name", value: "facilityName", sortable: false },
        { text: "City", value: "city", sortable: false },
        { text: "State", value: "state", sortable: false },
        { text: "Zip", value: "zip", sortable: false },
        { text: "Calls", value: "premiumCalls", sortable: false },
        { text: "Call Revenue", value: "callRevenue", sortable: false },
        { text: "Clicks", value: "premiumClicks", sortable: false },
        { text: "Click Revenue", value: "clickRevenue", sortable: false },
        { text: "Total", value: "total", sortable: false }
      ],

      paginationOptions: {
        itemsPerPage: 10,
        page: 1
      }
    };
  },

  components: {
    JsonCSV
  },

  computed: {
    csvData() {
      // console.log('')
      const facilities = JSON.parse(JSON.stringify(this.facilities));
      const CSVData = facilities.map(facility => {
        delete facility["rawFacility"];
        delete facility["rawCalls"];
        delete facility["rawClicks"];
        return facility;
      });
      // console.log('NEW CSV DATA', CSVData)
      return CSVData;
    },

    filename() {
      if (this.facilitySearchText) {
        return `${this.facilitySearchText}-activity-report-${this.startDate}-${this.endDate}`;
      } else if (this.companySearchText) {
        return `${this.companySearchText}-activity-report-${this.startDate}-${this.endDate}`;
      }
      return `activity-report-${this.startDate}-${this.endDate}`;
    },

    totalNumCalls() {
      let numCalls = 0;
      for (const facility of this.facilities) {
        numCalls += facility.premiumCalls;
      }
      return numCalls;
    },

    callsTotal() {
      let total = new Decimal(0);
      for (const facility of this.facilities) {
        if (facility.callRevenue) {
          total = total.add(facility.callRevenue.replace(/\$|,/g, ""));
        }
      }
      return total.toFixed();
    },

    totalNumClicks() {
      let numClicks = 0;
      for (const facility of this.facilities) {
        numClicks += facility.premiumClicks;
      }
      return numClicks;
    },

    clicksTotal() {
      let total = new Decimal(0);
      for (const facility of this.facilities) {
        if (facility.clickRevenue) {
          total = total.add(facility.clickRevenue.replace(/\$|,/g, ""));
        }
      }
      return total.toFixed();
    },

    totalTotal() {
      let total = new Decimal(0);
      for (const facility of this.facilities) {
        if (facility.total) {
          total = total.add(facility.total.replace(/\$|,/g, ""));
        }
      }
      return total.toFixed();
    }
  },

  async mounted() {
    await this.searchReport();
  },

  methods: {
    async searchReport() {
      this.offset = 0;
      this.paginationOptions.page = 1;

      await this.searchReport();
      this.awaitingSearch = false;
    },

    updatePaginationOptions(paginationOptions) {
      this.page = paginationOptions.page - 1;
      this.size = paginationOptions.itemsPerPage;

      this.getCompanies();
    },

    async getReport() {
      try {
        this.loading = true;
        const result = await getActivityRevenueReport(
          this.page,
          this.size,
          this.search
        );
        this.serverItemsLength = result.total;
        this.facilities = result.items;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    }
  }
};
</script>
